module.exports = {
    'CycleWords': require('./cycle-words'),
    'ScrollExperience': require('./scroll-experience'),
    'VerticalCarousel': require('./vertical-carousel'),
    'GlobalNavigation': require('./global-navigation'),
    'ExpandingGrid': require('./expanding-grid'),    
    'LoadMore': require('./load-more'),
    'VideoModal': require('./video-modal'),
    'SecondaryNavigation': require('./secondary-navigation'),    
    'InputAutoFocus': require('./input-auto-focus'),
    'TabSelect': require('./tab-select'),
    'ScrollToTop': require('./scroll-to-top'),
    'DataTable': require('./data-table'),
    'Resources': require('./resources'),
    'Pulsepoint': require('./pulsepoint'),
    'FeaturedContentColumns': require('./featured-content-columns'),
    'FeaturedPeople': require('./featured-people'),
    'SidebarBlocks': require('./sidebar-blocks'),
    'Wffm': require('./wffm'),
    'Careers': require('./careers'),
    'Locations': require('./locations'),
    'Analytics': require('./analytics'),
    'Events': require('./events'),
    'TableOfContents': require('./table-of-contents'),
    'ImageSlideshow': require('./image-slideshow'),
    'FeatureGridAndList': require('./feature-grid-and-list'),
    'TwoColumnTabs': require('./two-column-tabs'),
    'HeroWithImageAndLinks': require('./hero-with-image-and-links'),
    'Forms': require('./forms'),
    'UniversalPromoModule': require('./universal-promo-module'),
    'HubPage': require('./hub-page'),
    'AutoDownload': require('./auto-download'),
    'HeroWithClientStories': require('./hero-with-client-stories'),
    'Hero': require('./hero'),    
    'TopicAndTagFooterList': require('./topic-and-tag-footer-list'),
    'FeaturedTopicList': require('./featured-topic-list'),
    'InsightsDetail': require('./insights-detail'),
    'Authors': require('./authors'),
    'Pagination' : require('./pagination'),    
    'PersonalizedLinks': require('./personalized-links'),
    'VideoHero': require('./video-hero'),
    'VideoHeroSpinner': require('./video-hero-spinner'),
    'PopupModal': require('./popup-modal'),
    'VideoHeroBottom': require('./video-hero-bottom'),
    'IFramePage': require('./iframe-page'),
    'ParallaxModule': require('./parallax-module'),
    'LargeImage': require('./large-image'),
    'PersonDetail': require('./person-detail'),
    'Wistia': require('./wistia'),     
    'Lottie': require('./lottie'),
    'EmbeddedSubscriptionModule': require('./embedded-subscription-module'),
    'LandingPagesSearchFilter': require('./landing-pages-search-filter'),
    'GlobalSidePromo': require('./global-side-promo'),
    'CareersSearchHero': require('./careers-search-hero'),
    'LogosModule': require('./logos-module'),
    'FeaturedContentModule': require('./featured-content-module'),
    'TopicGroupLanding': require('./topic-group-landing'),
    'TopicLanding': require('./topic-landing'),
    'LargeCarouselModule': require('./large-carousel-module'),
    'ParagraphModule': require('./paragraph-module'),
    'CardGridModule': require('./card-grid-module'),
    'SearchRendering': require('./search-rendering'),
    'SearchControl': require('./search-control'),
    'ProductHeroModule': require('./product-hero-module'),
};
